module.exports = __webpack_public_path__ + "img/revenue.89075bb2.svg";